// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkout[data-v-1f28818c] {\r\n  background: #f6f6f6;\r\n  width: 100%;\r\n  padding: 0.5rem;\n}\n.content[data-v-1f28818c] {\r\n  width: 100%;\n}\n.container-stepper[data-v-1f28818c] {\r\n  margin: 1.5rem 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
